<div class="dialog-container">
  <h2 mat-dialog-title class="title">{{ data?.title | translate }}</h2>
  <div class="description">{{ data?.description | translate }}</div>
  <mat-dialog-content>
    <div class="content">
      <div class="spinner-container" *ngIf="loading">
        <mat-spinner diameter="80"></mat-spinner>
      </div>
      <div class="success-checkmark" *ngIf="!loading && newReceiver">
        <div class="check-icon">
          <span class="icon-line line-tip"></span>
          <span class="icon-line line-long"></span>
          <div class="icon-fix"></div>
        </div>
      </div>
      <div class="error-container" *ngIf="!loading && error">
        <div class="error-icon-container">
          <mat-icon class="error-icon">error</mat-icon>
          <div class="error-message">{{ error.reason | translate }}</div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      class="center-button"
      [style.background-color]="loading ? '#EBEDF0' : '#FFCC00'"
      [disabled]="loading"
      (click)="onOk()"
    >
      {{ data?.buttonText | translate }}
    </button>
  </mat-dialog-actions>
</div>
